export default __webpack_public_path__ + "static/media/home.31e101c6.png";